import { Injectable } from '@angular/core';
import { cloneDeep, isEqual } from 'lodash';

export interface DirtyTrackerOptions<T> {
  snapshot: (value: T) => any;
}

export class DirtyTracker<T> {
  private cleanSnapshot: any = null;

  constructor(private options: DirtyTrackerOptions<T>) {}

  markClean(value: T) {
    this.cleanSnapshot = this.options.snapshot(value);
  }

  isDirty(value: T): boolean {
    if (!value || !this.cleanSnapshot) {
      return false;
    }
    const current = this.options.snapshot(value);

    // log here if you are seeing dirty check when you have made no changes

    return !isEqual(current, this.cleanSnapshot);
  }
}

@Injectable()
export class DirtyTrackingService {
  createTracker<T>(options: DirtyTrackerOptions<T>): DirtyTracker<T> {
    return new DirtyTracker<T>(options);
  }

  // helper for browser confirm-on-leave
  handleBeforeUnload(event: BeforeUnloadEvent, isDirty: boolean, disabled: boolean) {
    if (disabled || !isDirty) {
      return;
    }

    event.preventDefault();
    event.returnValue = '';
  }
}

export function deepClone<T>(value: T): T {
  return cloneDeep(value);
}



// WEBPACK FOOTER //
// ./src/services/jacking-v2/dirty-tracking.service.ts